import React from 'react';
import CopyLink from '../../assets/images/copy_link.svg';
import Linkedin from '../../assets/images/linkedin.svg';
import Meta from '../../assets/images/meta.svg';
import X from '../../assets/images/x.svg';
import { classNames } from '../../utils/style';
import { textBody } from '../../styles/typography';
import { useCopyToClipboard } from '../../utils/useCopyToClipboard';
import { Tooltip } from '@payfit/midnight/dist/Tooltip';
import { t } from './translations';

export interface MediaShareLinksProps {
  url: string;
  locale?: 'fr' | 'en' | 'es';
  title?: string;
  copylinkDisabled?: boolean;
  linkedinDisabled?: boolean;
  metaDisabled?: boolean;
  xDisabled?: boolean;
}

export const MediaShareLinks = ({
  url,
  locale = 'en',
  title,
  copylinkDisabled,
  linkedinDisabled,
  metaDisabled,
  xDisabled,
}: MediaShareLinksProps) => {
  const [isCopied, handleCopy] = useCopyToClipboard();

  return (
    <div className={classNames('MediaShareLinks', 'flex flex-col gap-3')}>
      <div className={classNames(textBody, 'text-neutral-300')}>
        {title || t?.[locale].share}
      </div>
      <div className="flex gap-[10px]">
        {!copylinkDisabled && (
          <Tooltip
            tooltipContent={isCopied ? t?.[locale].copyToClipboard : null}
          >
            <button onClick={() => handleCopy(url)} aria-label="Copy">
              <CopyLink className="h-24 w-24" />
            </button>
          </Tooltip>
        )}
        {!linkedinDisabled && (
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
          >
            <Linkedin className="h-24 w-24" />
          </a>
        )}
        {!metaDisabled && (
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}>
            <Meta className="h-24 w-24" />
          </a>
        )}
        {!xDisabled && (
          <a href={`http://twitter.com/share?url=${url}`}>
            <X className="h-24 w-24" />
          </a>
        )}
      </div>
    </div>
  );
};
